import { render, staticRenderFns } from "./LiveTicket.vue?vue&type=template&id=4cc68e21&scoped=true&"
import script from "./LiveTicket.vue?vue&type=script&lang=js&"
export * from "./LiveTicket.vue?vue&type=script&lang=js&"
import style0 from "./LiveTicket.vue?vue&type=style&index=0&id=4cc68e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc68e21",
  null
  
)

export default component.exports